import * as React from "react";
import { RouteHistoryContext } from "./RouteHistoryContext";
import { RouteHistoryContextType } from "./RouteHistoryContextTypes";

export function useRouteHistory() {
    const context = React.useContext<[RouteHistoryContextType, () => void]>(RouteHistoryContext);
    if (!context) {
        throw new Error("useRouteContext must be used within a RouteContextProvider");
    }
    return context;
}
